import { useEffect, type RefObject } from "react";

const CSS_VAR = "--nbs-sticky-filters-height";

/**
 * Publishes the sticky filter bar height so other sticky chrome (e.g. N1 tabs)
 * can sit just underneath without overlapping.
 */
export function useStickyFiltersHeight(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;

    const root = document.querySelector(".nbs-shell") as HTMLElement | null;
    const target = root ?? document.documentElement;

    const publish = () => {
      const height = Math.ceil(el.getBoundingClientRect().height);
      target.style.setProperty(CSS_VAR, `${height}px`);
    };

    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(el);

    return () => {
      observer.disconnect();
      // Only clear if we still own the published value (another bar may have taken over).
      if (target.style.getPropertyValue(CSS_VAR)) {
        target.style.setProperty(CSS_VAR, "0px");
      }
    };
  }, [ref]);
}
